var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"betslip-footer"},[_c('BinarySwitcher',_vm._b({staticClass:"betslip-footer__binary-switcher",attrs:{"value":_vm.value},on:{"change":_vm.onTypeClick}},'BinarySwitcher',_vm.switcherOptions,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d118edc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/betSlip/BetSlipFooter.vue
// module id = 2087
// module chunks = 0